import { render } from "./AppPortfolio.vue?vue&type=template&id=ce471dd6"
import script from "./AppPortfolio.vue?vue&type=script&lang=js"
export * from "./AppPortfolio.vue?vue&type=script&lang=js"

import "./AppPortfolio.vue?vue&type=style&index=0&id=ce471dd6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__